import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIaacMetricsRequest } from "../../../store/iaac/actions";
import { getIaacSubscriptionRequest } from "../../../store/iaacSubscription/actions";

export const useIaCData = (orgCode) => {
  const dispatch = useDispatch();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const iaacMetrics = useSelector(
    (state) => state.iaac.metrics
  );
  const iaacMetricsLoading = useSelector(
    (state) => state.iaac.isIaacMetricsGetting
  );
  const iaacMetricsError = useSelector(
    (state) => state.iaac.getIaacMetricsError
  );

  const iaacSubscription = useSelector(
    (state) => state.iaacSubscription.subscription
  );
  const iaacSubscriptionLoading = useSelector(
    (state) => state.iaacSubscription.isIaacSubscriptionGetting
  );
  const iaacSubscriptionError = useSelector(
    (state) => state.iaacSubscription.getIaacSubscriptionError
  );

  const hasFetched = useRef(false);

  useEffect(() => {
    if (orgCode && !hasFetched.current) {
      dispatch(getIaacMetricsRequest(orgCode));
      dispatch(getIaacSubscriptionRequest(orgCode));
      hasFetched.current = true;
    }
  }, [dispatch, orgCode]);

  useEffect(() => {
    if (iaacMetrics && iaacSubscription) {
      const totalTemplates = iaacMetrics.total || 0;
      const limit = iaacSubscription.limit || 0;
      const usageRatio = limit > 0 ? totalTemplates / limit : 0;
      
      setData({
        ...iaacMetrics,
        subscription: iaacSubscription.subscription,
        price: iaacSubscription.price,
        limit: limit,
        totalTemplates: totalTemplates,
        usageRatio: usageRatio
      });
    }
    setLoading(iaacMetricsLoading || iaacSubscriptionLoading);
    if (iaacMetricsError || iaacSubscriptionError) {
      setData({
        total: 0,
        passed: 0,
        failed: 0,
        high: 0,
        medium: 0,
        low: 0,
        critical: 0,
        info: 0,
        scriptTypeCounts: {},
        subscription: null,
        price: 0,
        limit: 0,
        totalTemplates: 0,
        usageRatio: 0
      });
    }
    setError(null);
  }, [iaacMetrics, iaacMetricsLoading, iaacMetricsError, iaacSubscription, iaacSubscriptionLoading, iaacSubscriptionError]);

  return { data, loading, error };
}; 